import { LOCALES, useLocale } from "../i18n";

/** Segmentový přepínač jazyka (CS / EN) v horní liště. */
export default function LanguageSwitcher() {
  const { locale, setLocale } = useLocale();
  return (
    <div className="lang-switch" role="group" aria-label="Language">
      {LOCALES.map((l) => (
        <button
          key={l}
          type="button"
          className={l === locale ? "lang active" : "lang"}
          aria-pressed={l === locale}
          onClick={() => setLocale(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
